import { Topbar } from '@/components/organisms/Topbar';
import { Skeleton } from '@/components/ui/skeleton';
import { SectionCard } from './common';
import { ProfileIdentitySkeleton } from './section-skeletons';

/**
 * `/settings` route pending state: Topbar + a rail-shaped skeleton beside the
 * panel, matching `SettingsPage`'s shell and closing the route-transition gap.
 * The panel uses the PROFILE shape, since `profile` is the default section.
 */
export function SettingsPendingState() {
  return (
    <>
      <Topbar crumbs={[{ label: 'Account' }, { label: 'Settings' }]} title="Settings" />

      <div
        className="flex min-h-0 flex-1 flex-col overflow-auto"
        style={{ background: 'var(--canvas)' }}
      >
        <div
          className="mx-auto flex w-full flex-1 flex-col gap-6 px-4 py-6 md:flex-row md:gap-8 md:px-8 md:py-6"
          aria-busy="true"
          aria-live="polite"
        >
          {/* Same wrapper/nav split as the real `SettingsRail`: the outer box
              stretches full height and carries the divider, the inner one
              stays naturally sized and sticky — see that component's doc
              comment for why sticky and the full-height divider can't be the
              same box. */}
          <div className="w-full shrink-0 md:w-[232px] md:border-r" style={{ borderColor: 'var(--ink-200)' }}>
            <div className="flex w-full flex-row gap-2 overflow-x-auto pb-2 md:sticky md:top-6 md:flex-col md:gap-4 md:pb-0 md:pr-3">
              {Array.from({ length: 3 }, (_, g) => (
                <div key={g} className="flex shrink-0 flex-row gap-1.5 md:flex-col">
                  {Array.from({ length: 3 }, (_, i) => (
                    <Skeleton key={i} className="h-[34px] w-24 shrink-0 rounded-lg md:w-full" />
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="flex min-w-0 flex-1 flex-col gap-6">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-6 w-40 rounded" />
              <Skeleton className="h-4 w-72 rounded" />
            </div>
            <SectionCard tight>
              <ProfileIdentitySkeleton />
            </SectionCard>
          </div>
        </div>
      </div>
    </>
  );
}
